/*
 * Copyright (c) 2020 General Electric Company. All rights reserved.
 *
 * The copyright to the computer software herein is the property of
 * General Electric Company. The software may be used and/or copied only
 * with the written permission of General Electric Company or in accordance
 * with the terms and conditions stipulated in the agreement/contract
 * under which the software has been supplied.
 */

export class ViewerContextItem {
  accession: string; // Accession number
  NCD; // Requested procedure ID
  mrn: string; // MRN number
  imageCount = 0;
  token = ''; // Unique ID for context management in Lineshaft
  readOnlyExam = false; // Read only property
  studyDataAvailability = ''; // Study data availability
  disableAutoLaunchViewer;
  archiveAdoptedStatus;
  isViewerOpened;
  ownerInstance;
  isGlobalExam = false;
  siteId = '';

  constructor(accessionNumber: string, ncdIdentifier: number) {
    this.accession = accessionNumber;
    this.NCD = ncdIdentifier;
    this.mrn = '';
  }
}
